import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import {
    Checkbox,
    Input
} from "@chakra-ui/react";

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import View from '@material-ui/icons/Visibility';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    View: forwardRef((props, ref) => <View {...props} ref={ref} />)
};

function Table(
    {
        columns,
        data,
        title = "",
        viewUrl = "",
        addUrl = "",
        editUrl = "",
        addFn = null,
        addToolTip = 'Add New',
        viewFn = null,
        editFn = null,
        deleteFn = null,
        disableAdd = true,
        disableView = true,
        disableDelete = true,
        disableEdit = true,
        actionsPosition = -1,
        pageSize = 5,
        toolbarIsVisible = true,
        pagingIsAllowed = true,
        useBasicTemplate = true,
        fontSize = 14,
        layout = 'auto',
        loading = false,
        dateVal = null,
        minDateVal = null,
        maxDateVal = null,
        setReportFilter = null,
        showFilter = false,
        disableFilter = true,
        disableDateFilter = true,
        showFilterHandler = null,
        addControl = null,
        filename = 'data'
    }
) {

    columns = columns.map((column) => {
        return { ...column };
    });

    const editRow = (row) => {
        if (editFn)
            editFn(row);
    }

    const addRow = () => {
        if (addFn) {
            addFn();
        }
    }

    const viewRow = (row) => {
        if (viewFn)
            viewFn(row);
    }

    const deleteRow = (row) => {
        if (deleteFn)
            deleteFn(row);
    }

    return (
        (useBasicTemplate) ? <MaterialTable
            icons={tableIcons}
            title={title}
            columns={columns}
            data={data}
            isLoading={loading}
            options={{
                search: true,
                toolbar: toolbarIsVisible,
                paging: pagingIsAllowed,
                headerStyle: {
                    fontWeight: 'bold',
                    fontSize: fontSize,
                },
                rowStyle: {
                    fontSize: fontSize,
                },
                exportAllData: true,
                tableLayout: layout,
                filtering: showFilter,
                pageSize,
                exportFileName: filename,
                pageSizeOptions: [5, 10, 20, 50, 100],
                exportButton: {
                    csv: true,
                    pdf: true,
                }
            }}
        />
            :
            <MaterialTable
                icons={tableIcons}
                title={title}
                columns={columns}
                data={data}
                isLoading={loading}
                options={{
                    search: true,
                    searchFieldAlignment: 'left',
                    toolbar: toolbarIsVisible,
                    paging: pagingIsAllowed,
                    headerStyle: {
                        fontWeight: 'bold',
                        fontSize: fontSize,
                    },
                    rowStyle: {
                        fontSize: fontSize,
                    },
                    actionsColumnIndex: actionsPosition,
                    exportAllData: true,
                    filtering: showFilter,
                    pageSize,
                    exportFileName: filename,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                    exportButton: {
                        csv: true,
                        pdf: true,
                    }
                }}
                actions={[
                    {
                        icon: () =>
                            <Input
                                placeholder="Select Date and Time"
                                size="md"
                                type="date"
                                value={dateVal}
                                onChange={e => setReportFilter(e.target.value)}
                                min={minDateVal}
                                max={maxDateVal}
                            />
                        ,
                        isFreeAction: true,
                        hidden: disableDateFilter
                    },
                    {
                        icon: () =>
                            <Checkbox colorScheme='gray' checked={showFilter} size='lg' px='2' onChange={e => showFilterHandler(e)}>Filter</Checkbox>
                        ,
                        isFreeAction: true,
                        hidden: disableFilter
                    },
                    {
                        icon: () => addControl === null ? <AddBox /> : addControl,
                        tooltip: addToolTip,
                        isFreeAction: true,
                        onClick: (event) => addRow(),
                        hidden: disableAdd
                    },
                    rowData => ({
                        icon: () => <View />,
                        tooltip: 'View details',
                        onClick: (event, rowData) => viewRow(rowData),
                        hidden: disableView
                    }),
                    rowData => ({
                        icon: () => <Edit style={{ fontSize: '16px', color: '#3c98ed' }} />,
                        tooltip: 'Edit',
                        onClick: (event, rowData) => editRow(rowData),
                        hidden: disableEdit
                    }),
                    rowData => ({
                        icon: () => <DeleteOutline style={{ fontSize: '16px', color: '#cc0000' }} />,
                        tooltip: 'Delete',
                        onClick: (event, rowData) => deleteRow(rowData),
                        hidden: disableDelete
                    })
                ]}
                localization={{
                    header: {
                        actions: ""
                    }
                }}
            />
    );
}

export default Table;